var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7311 7.33111C18.024 7.03821 18.024 6.56334 17.7311 6.27045C17.4382 5.97756 16.9633 5.97756 16.6704 6.27046L12.0006 10.9404L7.33114 6.27048C7.03826 5.97757 6.56338 5.97755 6.27048 6.27043C5.97757 6.56331 5.97755 7.03818 6.27043 7.33109L10.94 12.0011L6.27045 16.6707C5.97756 16.9635 5.97756 17.4384 6.27046 17.7313C6.56335 18.0242 7.03823 18.0242 7.33112 17.7313L12.0006 13.0618L16.6696 17.7313C16.9625 18.0242 17.4374 18.0242 17.7303 17.7313C18.0232 17.4385 18.0232 16.9636 17.7304 16.6707L13.0612 12.0011L17.7311 7.33111Z",
    fill: "#121865"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7311 7.33111C18.024 7.03821 18.024 6.56334 17.7311 6.27045C17.4382 5.97756 16.9633 5.97756 16.6704 6.27046L12.0006 10.9404L7.33114 6.27048C7.03826 5.97757 6.56338 5.97755 6.27048 6.27043C5.97757 6.56331 5.97755 7.03818 6.27043 7.33109L10.94 12.0011L6.27045 16.6707C5.97756 16.9635 5.97756 17.4384 6.27046 17.7313C6.56335 18.0242 7.03823 18.0242 7.33112 17.7313L12.0006 13.0618L16.6696 17.7313C16.9625 18.0242 17.4374 18.0242 17.7303 17.7313C18.0232 17.4385 18.0232 16.9636 17.7304 16.6707L13.0612 12.0011L17.7311 7.33111Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.82010501f64195db124c805360534d80.svg";
export { ForwardRef as ReactComponent };